// @flow
// This file is automatically generated by scripts/build-corejs3-shipped-proposals.js

export default new Set<string>([
]);
